var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"bg-primary"},[_c('div',{staticClass:"flex flex-row justify-center items-center container mx-auto px-20"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{staticClass:"py-4 w-48 h-auto",attrs:{"src":_vm.navLogo}})])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }